import React from 'react';
import './Terms.css';

const Terms = () => {
  return (
    <main className="terms-main">
      <div className="terms-hero">
        <div className="terms-hero-content">
          <h1>📜 Terms and Conditions – Wonder Eventzz</h1>
          <p>Last updated: November 2025</p>
        </div>
      </div>

      <div className="terms-content">
        <div className="terms-section">
          <p className="intro-text">
            These Terms and Conditions outline the rules and regulations for using the website and services of Wonder Eventzz, located in Noida, India.
          </p>
        </div>

        <div className="terms-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or booking our services, you agree to comply with these Terms and Conditions.
          </p>
        </div>

        <div className="terms-section">
          <h2>2. Services</h2>
          <p>
            Wonder Eventzz provides balloon decoration and event decoration services for birthdays, anniversaries, and other celebrations. All bookings are subject to availability and confirmation.
          </p>
        </div>

        <div className="terms-section">
          <h2>3. Booking and Payment</h2>
          <ul>
            <li>Bookings can be made through call, WhatsApp, or our website.</li>
            <li>Advance payment may be required to confirm bookings.</li>
            <li>Cancellation within 24 hours of the event may result in partial or full payment forfeiture.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>4. Pricing</h2>
          <p>
            All prices are subject to change without notice. Any custom decoration request may include additional charges.
          </p>
        </div>

        <div className="terms-section">
          <h2>5. Liability</h2>
          <ul>
            <li>Wonder Eventzz is not responsible for delays caused by weather, traffic, or third-party issues.</li>
            <li>We are not liable for damages caused by misuse or interference with decorations after installation.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>6. Intellectual Property</h2>
          <p>
            All content on this website (text, images, designs, logos) is owned by Wonder Eventzz. Unauthorized use or reproduction is prohibited.
          </p>
        </div>

        <div className="terms-section">
          <h2>7. Cancellation & Refund</h2>
          <ul>
            <li>Cancellations made 48 hours prior to the event may qualify for a refund or rescheduling.</li>
            <li>Refunds are processed within 7–10 business days (if applicable).</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>8. Changes to Terms</h2>
          <p>
            We may update these Terms from time to time. Updated terms will be posted on this page with a revised date.
          </p>
        </div>

        <div className="terms-section">
          <h2>9. Contact Us</h2>
          <p>For any questions regarding these Terms:</p>
          <div className="contact-info">
            <p>📩 Email: <a href="mailto:support@wondereventzz.com">support@wondereventzz.com</a></p>
            <p>📞 Phone: <a href="tel:+919001971755">9001971755</a></p>
            <p>🏢 Address: Shiv Mandir Sector 49, Noida, India</p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Terms;

